/**
 * Initial floor plan traced from Roborock vacuum map.
 * All coordinates in meters, origin at top-left of apartment.
 * Calibration: living room = 6m wide × 11m deep.
 * Total apartment ≈ 130m².
 *
 * Coordinate system:
 *   x = left-to-right (width)
 *   y = top-to-bottom (depth)
 */

export const INITIAL_FLOOR_PLAN = {
  // Apartment bounding box (meters)
  width: 12.5,
  height: 11,

  rooms: [
    {
      id: "living-room",
      name: "Living Room",
      color: "#4A9BD9",
      polygon: [
        { x: 0, y: 0 },
        { x: 6, y: 0 },
        { x: 6, y: 11 },
        { x: 0, y: 11 },
      ],
    },
    {
      id: "bedroom",
      name: "Bedroom",
      color: "#D4744A",
      polygon: [
        { x: 0, y: 7 },
        { x: 4, y: 7 },
        { x: 4, y: 11 },
        { x: 0, y: 11 },
      ],
    },
    {
      id: "kitchen",
      name: "Kitchen",
      color: "#D4744A",
      polygon: [
        { x: 6, y: 3.5 },
        { x: 10, y: 3.5 },
        { x: 10, y: 8 },
        { x: 6, y: 8 },
      ],
    },
    {
      id: "office",
      name: "Office",
      color: "#4ABDA5",
      polygon: [
        { x: 8.5, y: 0 },
        { x: 12.5, y: 0 },
        { x: 12.5, y: 3.5 },
        { x: 8.5, y: 3.5 },
      ],
    },
    {
      id: "hallway",
      name: "Hallway",
      color: "#6B7B8D",
      polygon: [
        { x: 6, y: 0 },
        { x: 8.5, y: 0 },
        { x: 8.5, y: 3.5 },
        { x: 6, y: 3.5 },
      ],
    },
    {
      id: "bathroom",
      name: "Bathroom",
      color: "#D4744A",
      polygon: [
        { x: 10, y: 3.5 },
        { x: 12.5, y: 3.5 },
        { x: 12.5, y: 6.5 },
        { x: 10, y: 6.5 },
      ],
    },
    {
      id: "laundry",
      name: "Laundry",
      color: "#D4744A",
      polygon: [
        { x: 10, y: 6.5 },
        { x: 12.5, y: 6.5 },
        { x: 12.5, y: 8 },
        { x: 10, y: 8 },
      ],
    },
    {
      id: "entrance",
      name: "Entrance",
      color: "#6B7B8D",
      polygon: [
        { x: 6, y: 8 },
        { x: 12.5, y: 8 },
        { x: 12.5, y: 11 },
        { x: 6, y: 11 },
      ],
    },
  ],

  // Doors / passages between rooms.
  //   type: "swing" (normal hinged), "sliding", or "open" (no door, walk-through)
  //   x, y: center position in meters
  //   width: opening width in meters
  //   angle: rotation in degrees (0 = opening runs along the X axis / horizontal wall)
  doors: [],

  // Staircases.
  //   x, y: center position in meters
  //   width: stair width in meters, length: run length (depth) in meters
  //   angle: rotation in degrees (0 = run goes along the Y axis)
  //   direction: "up" or "down"
  stairs: [],

  // Sensing nodes (composite units mounted on walls).
  //   kind: "full" (camera+sensor+lux), "full_nolux" (camera+sensor),
  //         "simple" (sensor+lux), "simple_nolux" (sensor only)
  //   x, y: position in meters, room: auto-detected room id
  //   sensors[]: each STHS34PF80 — { id, rotation (deg aim), fovAngle, rangeM, reliableM }
  //   camera: { rotation, fovAngle, rangeM } | null
  nodes: [],

  // WiZ light fixtures. Each marker is one physical lamp grouping N WiZ bulbs.
  //   bulbs[]: { mac (12-hex lowercase), name }
  lights: [],

  // Resting places / furniture (dwell zones). A seated or still person is only
  // reliably detected within the inner ~2 m ring, so these are scored against
  // each sensor's reliableM, not the full presence cone.
  //   x, y: top-left corner in meters, w, h: size in meters, label, room
  dwellZones: [],

  // Walk-paths used by the coverage optimizer.
  //   points[]: { x, y } in meters (order = travel direction)
  //   bidirectional: true if walked both ways (lead-in evaluated at both ends)
  paths: [],
};
